import getListServicesSaga from "./getServicesSaga";

export default getListServicesSaga;